import MuiAlert, { AlertProps } from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";

function Alert(props: AlertProps) {
	return <MuiAlert elevation={6} variant="filled" {...props} />;
}

interface CustomizedSnackbarsProps {
	isOpen: boolean;
	hideDuration?: number;
	setValid?: (value: boolean) => void;
	type: AlertProps["severity"];
	message: React.ReactNode;
}

export default function CustomizedSnackbars(props: CustomizedSnackbarsProps) {
	const handleClose = (_event: React.SyntheticEvent | Event, reason?: string) => {
		if (reason === "clickaway") {
			return;
		}

		props.setValid?.(true);
	};

	return (
		<Snackbar
			open={props.isOpen}
			autoHideDuration={props.hideDuration || 2000}
			onClose={handleClose}
		>
			<div>
				<Alert onClose={handleClose} severity={props.type}>
					{props.message}
				</Alert>
			</div>
		</Snackbar>
	);
}
